import * as React from 'react';

import {useGetSessionUser} from '../core/use-get-session-user';

import {TeamAiSidebarHome} from './team-ai-sidebar-home';
import {useTeamAiSidebarToggle} from './use-team-ai-sidebar-toggle';

import styles from './team-ai-sidebar.module.css';

export function TeamAiRoot() {
    const setTeamAiSidebarToggle = useTeamAiSidebarToggle();

    const {user} = useGetSessionUser();

    const userCanAccessSetup = Boolean(user && user.permissions && user.permissions.canAccessSetup);

    const agentMount = document.getElementById('team-ai-sidebar');
    const isAiAgentSidebarOpen = agentMount
        ? agentMount.getAttribute('data-is-open') === 'true'
        : false;

    const handleClick = () => {
        const userId = user ? user.id : null;
        if (userId) {
            setTeamAiSidebarToggle(userId, !isAiAgentSidebarOpen);
        }
    };

    return (
        <>
            <div className={styles.wrapper}>
                <TeamAiSidebarHome
                    onClose={handleClick}
                    isSidebarOpen={isAiAgentSidebarOpen}
                    userCanAccessSetup={userCanAccessSetup}
                />
            </div>
        </>
    );
}
